import React, { ReactNode } from 'react'

import { Col, Row } from 'antd'

import Union from '../assets/images/union.svg'

interface Props {
  headerTitle: string
  headerItems: string[]
  children?: ReactNode
}

const RightSection: React.FC<Props> = ({ headerTitle, headerItems }) => {
  const items: ReactNode = headerItems.map((item: string, index: number) => {
    return (
      <p className="page-header__item" key={index}>
        {/*<Icon type="bullet" className="page-header__icon" />*/}
        <li>{item}</li>
      </p>
    )
  })
  return (
    <div className={'t-right-section'}>
      <Row>
        <img src={Union} alt="union" className="right-section__image t-right-section_img" />
      </Row>
      <Col span={14} offset={6} className="right-section__content">
        <h3 className="right-section__content_title">PeopleKeep</h3>
        {items}
      </Col>
    </div>
  )
}

export default RightSection
